import initialState from './initialState';
import { CASE_DATA, UNLOAD_ALL_CASES, UNLOAD_CASE_AS_ACTIVE } from '../actions/actionTypes';
import { loadActiveCases } from '../store/browserStorage';

export default function activeCasesReducer(state = initialState.activeCases, action) {
  switch (action.type) {
    case CASE_DATA: {
      const newCaseNumber = action.caseInfo.caseDetail.caseNumber;
      const localStorageCases = localStorage.getItem('activeCases')
        ? JSON.parse(localStorage.getItem('activeCases'))
        : [];
      const alreadyActive = localStorageCases.indexOf(newCaseNumber) !== -1;
      const newActiveCases =
        action.caseInfo.activeCase && !alreadyActive ? [...localStorageCases, newCaseNumber] : [...localStorageCases];
      localStorage.setItem('activeCases', JSON.stringify(newActiveCases));
      return newActiveCases;
    }
    case UNLOAD_CASE_AS_ACTIVE: {
      const localStorageCases = loadActiveCases();
      const remainingActiveCases = [...localStorageCases.filter((activeCase) => activeCase !== action.caseNumber)];
      localStorage.setItem('activeCases', JSON.stringify(remainingActiveCases));
      return remainingActiveCases;
    }

    case UNLOAD_ALL_CASES: {
      localStorage.setItem('activeCases', JSON.stringify([]));
      return [];
    }

    default:
      return state;
  }
}
